import { graphql } from '@guuru/graphql-common/gql';
import {
  CHAT_MESSAGE_FIELDS as MessageFields,
  CHAT_PUBLIC_FIELDS as ChatPublicFields,
} from '@guuru/graphql-web';

export default graphql(
  `
    mutation CreateChat(
      $input: ChatInput!
      $isVisibleByExpert: Boolean = false
      $isVisibleByUser: Boolean = true
    ) {
      createChat(input: $input) {
        ...ChatPublicFields
        token
        messages(
          isVisibleByExpert: $isVisibleByExpert
          isVisibleByUser: $isVisibleByUser
          orderBy: { direction: asc, field: createdAt }
        ) {
          edges {
            node {
              ...MessageFields
            }
          }
        }
      }
    }
  `,
  [MessageFields, ChatPublicFields],
);
